import { render, staticRenderFns } from "./RefListItems.vue?vue&type=template&id=0abffb2c&"
import script from "./RefListItems.vue?vue&type=script&lang=ts&"
export * from "./RefListItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports